'use client'

import React from 'react'

import { MImage } from '../../../../core/MImage'
import { cn } from '../../../../utils/cn'

export interface ITextAIllustrationProps {
	src: string
	alt: string
	className?: string
}

export const TextAIllustration: React.FC<ITextAIllustrationProps> = ({ src, alt, className }) => (
	<MImage src={src} alt={alt} className={cn('m-text-a__illustration', className)} />
)

TextAIllustration.displayName = 'ATextAIllustration'
